/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TweenLite, Linear, RoughEase} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {SpacierArcade} from "../SpacierArcade";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {TimelineLite} from "gsap";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {SASymbols, SpacierArcadeReelSymbol} from "../symbols/SpacierArcadeReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SAReelController} from "../reel/SAReelController";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeWildSymbol} from "../symbols/SpacierArcadeWildSymbol";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class ReelStop implements GameRoundPresentation {
    private readonly _reelId:number;
    private _stopDelay:number;
    private _quickStopDelay:number;
    stagger?:number;
    abortStagger?:number;
    private _tl:Timeline;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._stopDelay = SpacierArcade.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = SpacierArcade.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if(stagger != undefined) {
            this._stopDelay = stagger;
        }
        if(abortStagger != undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;

    }

    private hasWildOnReel(data:SpacierArcadeParsedGameData):boolean{
        return data.overlayWildsMultipliers[this._reelId].filter(m => m > 0).length > 0;
    }


    public prepare(data:SpacierArcadeParsedGameData):void {
        const wildindex = data.fsWildOnReelExcitement.indexOf(true);
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;
        // if(this._reelId === wildindex && this.isWinOrNextRespin(data) && (data.mode === SpacierArcadeGameMode.NORMAL || data.mode === SpacierArcadeGameMode.FREESPIN)){
            // this.stagger += ((data.payoutMultiplier - 1) * 0.4) + 1;
        // }
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        let saReelController:SAReelController = <SAReelController>Reels.getReel(this._reelId);
        saReelController.updateGameData(data);
        const tl:TimelineLite = SpacierArcade.timelineReelsController.stopSpin(this._reelId, data, false);
        tl.add([
            this.getBounceAnimation(data)
        ], "-=0.5");
        const bounceTiming = -0.25;
        const bounceTime = tl.duration() + bounceTiming;
        if(!GameSetting.isFastSpin || (GameSetting.isFastSpin && this._reelId === 1 || this._reelId === 2  || this._reelId === 4)) {
            tl.add(() => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.REELS_DEFAULT_BOUNCE[this._reelId]), bounceTime)
        }
        this._tl = tl;
        return this._tl;
    }

    private getBounceAnimation(data:SpacierArcadeParsedGameData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            if(data.scatterPositions![this._reelId] > -1){
                SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.SCATTER_1);
            }
        }, "+=0.35");
        tl.add(() => {
            let reelSymbols:(SpacierArcadeReelSymbol | null)[] = <(SpacierArcadeReelSymbol | null)[]>Reels.allSymbols(this._reelId);
            reelSymbols.forEach((symbol) => {
                if (symbol && (symbol.symName === SASymbols.S)) {
                    symbol.changeState({
                        state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.attention
                    });
                }
            });
        },0);
        return tl;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
            //Creating a new timeline with the same length as the time left on the active one, to make sure that the master timeline does not end before this one.
            const newTl = new TimelineLite();
            newTl.add(() => {
                let reelSymbols: (SpacierArcadeReelSymbol | null)[] = <(SpacierArcadeReelSymbol | null)[]>Reels.allSymbols(this._reelId);
                reelSymbols.forEach((symbol) => {
                    if (symbol && (symbol.symName === SASymbols.S)) {
                        symbol.changeState({
                            state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.attention
                        });
                    }
                });
            });
            newTl.add(new TweenLite(this, this._tl.duration() - this._tl.time(), {}));
            return newTl;
        }
        const tl: TimelineLite = SpacierArcade.timelineReelsController.stopSpin(this._reelId, data, true);
        tl.add([
            this.getBounceAnimation(data)
        ], "-=0.1");
        if(this._reelId === 1 || this._reelId === 2  || this._reelId === 4) {
            tl.add(() => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.REELS_DEFAULT_BOUNCE[this._reelId]), "-=0.35");
        }
        return tl;
    }

}